export const GarallyPhotoType = {
  oneShot: '1shot',
  oneShotAKB48: '1shot-AKB48',
  oneShotAKB48_62nd: '1shot-AKB48-62nd',
  oneShotAKB48_63rd: '1shot-AKB48-63rd',
  oneShotAKB48_64th: '1shot-AKB48-64th',
  oneShotAKB48_10th_AL: '1shot-AKB48-10th-AL',
  oneShotAKB48_65th: '1shot-AKB48-65th',
  twoShot: '2shot',
  twoShotWide: '2shot-wide',
  twoShotWidthFixed: '2shot-width-fixed'
}
